import React from 'react';
import Icon, { IconType } from './index';
import * as css from './iconWithLabel.module.scss';
import classnames from 'classnames';

interface IconWithLabelProps {
  label: string;
  iconType: IconType;
  title?: string;
  className?: string;
}

const IconWithLabel: React.FC<React.PropsWithChildren<IconWithLabelProps>> = ({
  label,
  title,
  className,
  iconType,
}) => (
  <div title={title} className={classnames(css.iconWithLabel, className)}>
    <Icon type={iconType} />
    {label}
  </div>
);

type SetIconWithLabelProps = Omit<IconWithLabelProps, 'iconType'>;

export const WarningIconWithLabel: React.FC<
  React.PropsWithChildren<SetIconWithLabelProps>
> = (props) => <IconWithLabel iconType={IconType.Warning} {...props} />;

export default IconWithLabel;
